<p>{{ updaterName }} changed the title to "{{ title }}"</p>
